import { render, staticRenderFns } from "./MulticartPlacement.vue?vue&type=template&id=5b219b54&scoped=true"
import script from "./MulticartPlacement.vue?vue&type=script&lang=js"
export * from "./MulticartPlacement.vue?vue&type=script&lang=js"
import style0 from "./MulticartPlacement.vue?vue&type=style&index=0&id=5b219b54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b219b54",
  null
  
)

export default component.exports